/* Company Confidential, Copyright (c) 2017 CRF Box, Ltd. All Rights Reserved. */

import RequestService from '../service/requestService';
import * as actionTypes from './actionTypes';
import * as actions from './actions';
import { ADD_NEW_PARTICIPANT_DOCUMENT_TITLE, PARTICIPANT_HAS_NEW_VERSIONS_TO_SIGN_TITLE } from '../const';
import {
  MODAL_TYPE_PARTICIPANT_HAS_NEW_VERSIONS,
  MODAL_TYPE_ADD_NEW_PARTICIPANT_DOCUMENT
} from '../constants/modalTypes';

export const participantStatusViewShowError = (error) => {
  return {
    type: actionTypes.PARTICIPANT_STATUS_VIEW_ERROR,
    payload: error
  };
};

export function loadParticipantStatuses() {
  return function (dispatch) {
    dispatch(participantStatusViewShowLoading());
    return RequestService.getFinalParticipantStatuses()
      .then((response) => {
        dispatch(fetchedParticipantStatuses(response));
      })
      .catch((err) => {
        dispatch(participantStatusViewShowError(err));
      });
  };
}

export const fetchedParticipantStatuses = (statuses) => {
  return {
    type: actionTypes.PARTICIPANT_STATUS_FETCH,
    payload: statuses
  };
};

export function saveParticipantStatus(payload, studyGid, participantId) {
  return function (dispatch) {
    return RequestService.saveParticipantStatus(payload)
      .then((response) => {
        dispatch(actions.fetchParticipantJourney(response.data.gid));
        dispatch(actions.hideModal());
        dispatch(actions.fetchDocuments({ studyId: studyGid, participantId }));
      })
      .catch((err) => {
        dispatch(participantStatusViewShowError(err));
      });
  };
}

export const participantStatusViewShowLoading = () => {
  return {
    type: actionTypes.PARTICIPANT_STATUS_VIEW_LOADING
  };
};

export function resetParticipantStatus(participantJourneyGid, studyGid, payload) {
  return function (dispatch) {
    return RequestService.resetParticipantStatus(participantJourneyGid, payload)
      .then((response) => {
        dispatch(actions.fetchParticipantJourney(response.data.gid));
        dispatch(actions.fetchDocuments({ studyId: studyGid, participantId: response.data.userId }));
        dispatch(actions.hideModal());
      })
      .catch((error) => {
        dispatch(participantStatusViewShowError(error));
      });
  };
}

export function checkParticipantHasNewVersions(participantJourneyGid, consentingGid) {
  return function (dispatch) {
    RequestService.checkParticipantHasNewVersions(participantJourneyGid).then((response) => {
      let hasNewVersions = response.data.hasNewVersions.hasNewVersions;
      if (hasNewVersions === true) {
        dispatch(actions.fetchConsenting(consentingGid));
        dispatch(actions.fetchAvailableDocuments(participantJourneyGid));
        dispatch(
          actions.showModal(MODAL_TYPE_PARTICIPANT_HAS_NEW_VERSIONS, {
            shouldCloseOnOverlayClick: true,
            className: 'participant-has-new-versions-modal',
            title: PARTICIPANT_HAS_NEW_VERSIONS_TO_SIGN_TITLE
          })
        );
      } else {
        dispatch(actions.hideModal());
      }
    });
  };
}

export function openAddNewDocumentModal() {
  return function (dispatch) {
    dispatch(
      actions.showModal(MODAL_TYPE_ADD_NEW_PARTICIPANT_DOCUMENT, {
        shouldCloseOnOverlayClick: true,
        className: 'add-new-participant-document-modal',
        title: ADD_NEW_PARTICIPANT_DOCUMENT_TITLE
      })
    );
  };
}
